export default "__VITE_ASSET__CBKpB7kt__"